import { TemplatePayload } from 'apps/orion/src/app/models/supply-visibility.model';
import { CommitTransactionDetails, VendorName } from '../../models/commit.model';
import { Forecast, ForecastVirtualVc } from '../../models/forecast.model';
import { PartNumberTransactionDetails } from '../../models/partnumbers-list.model';
import {
  BasicParameters,
  Commit,
  CommitsFilterDto,
  CumulativePayload,
  DateRangeParameters,
  DummyCommitDetail,
  DummyCommitHeader,
  DummyCommitHeadersFilter,
  EnumSvSidebarSection,
  FilterParams,
  PnReviewed,
  UserSettings,
  UserSettingsParameters,
} from '../../models/supply-visibility.model';
import { SVComments } from '../../models/sv-comments.model';
import { DashboardPanelModel } from '../../models/sv-dashboard';
import { SVNotes } from '../../models/sv-notes.model';
import { SVNotification } from '../../models/sv-notifications.model';
import { SVPredefinedComments } from '../../models/sv-predefined-comments.model';

import { VendorTransactionDetails } from '../vendors-list/vendors-list.types';
import { SupplyVisibilityAction as SupplyVisibilityActionType } from './supply-visibility.types';

export class SetCommits {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS;
}

export class SetCommitsError {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetCommitSuccess {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_SUCCESS;
}

export class GetDummyCommitHeaders {
  static readonly type = SupplyVisibilityActionType.GET_DUMMY_COMMIT_HEADERS;
  constructor(public readonly filter?: DummyCommitHeadersFilter) {}
}

export class GetDummyCommitHeadersError {
  static readonly type = SupplyVisibilityActionType.GET_DUMMY_COMMIT_HEADERS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class GetDummyCommitHeadersSuccess {
  static readonly type = SupplyVisibilityActionType.GET_DUMMY_COMMIT_HEADERS_SUCCESS;
}

export class CacheCommitsWithDummy {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_WITH_DUMMY;
  constructor(public readonly partNumber: { partNumber: string; vendorCode: string }) {}
}

export class CacheCommitsWithDummyError {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_WITH_DUMMY_ERROR;
  constructor(public readonly error: unknown) {}
}

export class CacheCommitsWithDummySuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_WITH_DUMMY_SUCCESS;
}

export class SetCommitsWithDummy {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_DUMMY;
  constructor(public readonly isRefreshCommit?: unknown) {}
}

export class SetCommitsWithDummyError {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_DUMMY_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetCommitsWithDummySuccess {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_DUMMY_SUCCESS;
}
export class SetCommitsWithFilter {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_FILTER;
  constructor(public readonly filter: CommitsFilterDto) {}
}

export class SetCommitsWithFilterError {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_FILTER_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetCommitsWithFilterSuccess {
  static readonly type = SupplyVisibilityActionType.SET_COMMITS_WITH_FILTER_SUCCESS;
}

export class GetNotifications {
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATIONS;
}

export class GetNotificationsError {
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATIONS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class GetNotificationsSuccess {
  constructor(public readonly notifications: SVNotification[]) {}
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATIONS_SUCCESS;
}

export class GetNotificationsUnreadCount {
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATIONS_UNREAD_COUNT;
}

export class GetNotificationsUnreadCountSuccess {
  constructor(public readonly count: number) {}
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATIONS_UNREAD_COUNT_SUCCESS;
}

export class ShowNotifications {
  constructor(public readonly id: string) {}
  static readonly type = SupplyVisibilityActionType.SHOW_NOTIFICATIONS;
}

export class GetNotificationDetails {
  constructor(public readonly id: string) {}
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATION_DETAILS;
}
export class GetNotificationDetailsSuccess {
  constructor(public readonly details: SVNotification) {}
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATION_DETAILS_SUCCESS;
}
export class GetNotificationDetailsError {
  static readonly type = SupplyVisibilityActionType.GET_NOTIFICATION_DETAILS_ERROR;
}

export class SetAllNotificationsAsRead {
  static readonly type = SupplyVisibilityActionType.SET_ALL_NOTIFICATIONS_AS_READ;
}

export class AddCommit {
  static readonly type = SupplyVisibilityActionType.ADD_COMMIT;
  constructor(public readonly commit: Commit) {}
}

export class EditCommit {
  static readonly type = SupplyVisibilityActionType.EDIT_COMMIT;
  constructor(public readonly commit: Commit) {}
}

export class EditCommitError {
  static readonly type = SupplyVisibilityActionType.EDIT_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class EditCommitSuccess {
  static readonly type = SupplyVisibilityActionType.EDIT_COMMIT_SUCCESS;
  constructor(public readonly commit?: Commit) {}
}

export class DeleteCommit {
  static readonly type = SupplyVisibilityActionType.DELETE_COMMIT;
  constructor(
    public readonly commit: Commit,
    public readonly baseModule?: string,
    public readonly lowerTriggerUrl?: string,
  ) {}
}

export class DeleteCommitError {
  static readonly type = SupplyVisibilityActionType.DELETE_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteCommitSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_COMMIT_SUCCESS;
}

export class AddCommitError {
  static readonly type = SupplyVisibilityActionType.ADD_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class AddCommitSuccess {
  static readonly type = SupplyVisibilityActionType.ADD_COMMIT_SUCCESS;
}

export class AddCommitNotify {
  static readonly type = SupplyVisibilityActionType.ADD_COMMIT_NOTIFY;
  constructor(public readonly commit: Commit) {}
}

export class AddDummyCommitHeader {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT_HEADER;
  constructor(
    public readonly commit: DummyCommitHeader,
    public readonly filter?: DummyCommitHeadersFilter,
  ) {}
}

export class AddDummyCommitHeaderError {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT_HEADER_ERROR;
  constructor(public readonly error: unknown) {}
}

export class AddDummyCommitHeaderSuccess {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT_HEADER_SUCCESS;
}

export class UpdateDummyCommitHeader {
  static readonly type = SupplyVisibilityActionType.UPDATE_DUMMY_COMMIT_HEADER;
  constructor(
    public readonly header: DummyCommitHeader,
    public readonly filter?: DummyCommitHeadersFilter,
  ) {}
}

export class UpdateDummyCommitHeaderError {
  static readonly type = SupplyVisibilityActionType.UPDATE_DUMMY_COMMIT_HEADER_ERROR;
  constructor(public readonly error: unknown) {}
}

export class UpdateDummyCommitHeaderSuccess {
  static readonly type = SupplyVisibilityActionType.UPDATE_DUMMY_COMMIT_HEADER_SUCCESS;
}

export class DeleteDummyCommitHeader {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT_HEADER;
  constructor(
    public readonly header: DummyCommitHeader,
    public readonly filter?: DummyCommitHeadersFilter,
  ) {}
}

export class DeleteDummyCommitHeaderError {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT_HEADER_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteDummyCommitHeaderSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT_HEADER_SUCCESS;
}

export class AddDummyCommit {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT;
  constructor(public readonly commit: DummyCommitDetail) {}
}

export class AddDummyCommitError {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class AddDummyCommitSuccess {
  static readonly type = SupplyVisibilityActionType.ADD_DUMMY_COMMIT_SUCCESS;
  constructor(public readonly commit: DummyCommitDetail) {}
}

export class EditDummyCommit {
  static readonly type = SupplyVisibilityActionType.EDIT_DUMMY_COMMIT;
  constructor(public readonly commit: DummyCommitDetail) {}
}

export class EditDummyCommitError {
  static readonly type = SupplyVisibilityActionType.EDIT_DUMMY_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class EditDummyCommitSuccess {
  static readonly type = SupplyVisibilityActionType.EDIT_DUMMY_COMMIT_SUCCESS;
}

export class CancelCommit {
  static readonly type = SupplyVisibilityActionType.CANCEL_COMMIT;
  constructor(public readonly commit: Commit) {}
}

export class CancelCommitSuccess {
  static readonly type = SupplyVisibilityActionType.CANCEL_COMMIT_SUCCESS;
}

export class CancelCommitError {
  static readonly type = SupplyVisibilityActionType.CANCEL_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeletePLO {
  static readonly type = SupplyVisibilityActionType.DELETE_PLO;
  constructor(public readonly commit: Commit) {}
}

export class DeletePLOSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_PLO_SUCCESS;
}

export class DeletePLOError {
  static readonly type = SupplyVisibilityActionType.DELETE_PLO_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteDummyCommit {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT;
  constructor(public readonly dummyCommitDetail: DummyCommitDetail) {}
}

export class DeleteDummyCommitError {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteDummyCommitSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_DUMMY_COMMIT_SUCCESS;
}

export class SetVendorCodes {
  static readonly type = SupplyVisibilityActionType.SET_VENDOR_CODES;
  constructor(public readonly partNumbers: string[]) {}
}

export class SetVendorCodesError {
  static readonly type = SupplyVisibilityActionType.SET_VENDOR_CODES_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetVendorCodesSuccess {
  static readonly type = SupplyVisibilityActionType.SET_VENDOR_CODES_SUCCESS;
}
export class SetPartNumberListParametersSuccess {
  constructor(
    public readonly widgetId: string,
    public readonly pnList: BasicParameters[],
  ) {}
  static readonly type = SupplyVisibilityActionType.SET_PART_NUMBER_LIST_PARAMETERS_SUCCESS;
}

export class SetPartNumberListParametersError {
  static readonly type = SupplyVisibilityActionType.SET_PART_NUMBER_LIST_PARAMETERS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetCommitVendorCode {
  static readonly type = SupplyVisibilityActionType.SET_COMMIT_VENDOR_CODE;
  constructor(public readonly vendorCode: string) {}
}

export class SetCommitModuleOn {
  static readonly type = SupplyVisibilityActionType.SET_COMMIT_MODULE_ON;
  constructor(public readonly isCommitModule: boolean) {}
}

export class SetCommitVendorCodeSuccess {
  static readonly type = SupplyVisibilityActionType.SET_COMMIT_VENDOR_CODE_SUCCESS;
}

export class SetBasicParameters {
  static readonly type = SupplyVisibilityActionType.SET_BASIC_PARAMETERS;
  constructor(public readonly parameters: BasicParameters) {}
}

export class SetPartNumberListParameters {
  static readonly type = SupplyVisibilityActionType.SET_PART_NUMBER_LIST_PARAMETERS;
  constructor(
    public readonly widgetId: string,
    public readonly pnList: BasicParameters[],
  ) {}
}

export class SetActiveVendor {
  static readonly type = SupplyVisibilityActionType.SET_ACTIVE_VENDOR;
  constructor(public readonly vendor: string) {}
}

export class SetPurchaseOrders {
  static readonly type = SupplyVisibilityActionType.SET_PURCHASE_ORDERS;
  constructor(public readonly parameters?: BasicParameters) {}
}
export class SetPurchaseOrdersForCM {
  static readonly type = SupplyVisibilityActionType.SET_PURCHASE_ORDERS_FOR_CM;
  constructor(public readonly parameters?: BasicParameters) {}
}

export class SetPurchaseOrdersError {
  static readonly type = SupplyVisibilityActionType.SET_PURCHASE_ORDERS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetPurchaseOrdersSuccess {
  static readonly type = SupplyVisibilityActionType.SET_PURCHASE_ORDERS_SUCCESS;
}

export class SetDateRangeParameters {
  static readonly type = SupplyVisibilityActionType.SET_DATE_RANGE_PARAMETERS;
  constructor(public readonly parameters?: DateRangeParameters) {}
}
export class SetDateRangeParametersSuccess {
  static readonly type = SupplyVisibilityActionType.SET_DATE_RANGE_PARAMETERS_SUCCESS;
  constructor(public readonly parameters?: DateRangeParameters) {}
}
export class SetDummyCommitHeader {
  static readonly type = SupplyVisibilityActionType.SET_DUMMY_COMMIT_HEADER;
  constructor(public readonly header?: DummyCommitHeader) {}
}

export class SetForecastWeekRange {
  static readonly type = SupplyVisibilityActionType.SET_FORECAST_WEEK_RANGE;
  constructor(
    public readonly start: number,
    public readonly end: number,
  ) {}
}

/* Forecast */
export class SetForecast {
  static readonly type = SupplyVisibilityActionType.SET_FORECAST;
  constructor(public readonly id?: string) {}
}

export class SetForecastError {
  static readonly type = SupplyVisibilityActionType.SET_FORECAST_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class SetForecastSuccess {
  static readonly type = SupplyVisibilityActionType.SET_FORECAST_SUCCESS;
  constructor(public readonly id?: string) {}
}

export class SetChildrenForecastSuccess {
  static readonly type = SupplyVisibilityActionType.SET_CHILDREN_FORECAST_SUCCESS;
  constructor(public readonly cachedChildrenForecast: { data: ForecastVirtualVc[] }) {}
}

export class SetChildrenPNList {
  static readonly type = SupplyVisibilityActionType.SET_CHILDREN_PN_LIST;
  constructor(
    public readonly parameters: BasicParameters,
    public readonly id: null | string,
  ) {}
}

export class CacheForecast {
  static readonly type = SupplyVisibilityActionType.CACHE_FORECAST;
  constructor(public readonly cacheParameters: BasicParameters) {}
}

export class CacheForecastError {
  static readonly type = SupplyVisibilityActionType.CACHE_FORECAST_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class CacheForecastSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_FORECAST_SUCCESS;
  constructor(public readonly cacheParameters: BasicParameters) {}
}

export class ResetSupplyVisibilityAndCommits {
  static readonly type = SupplyVisibilityActionType.RESET_SUPPLY_VISIBILITY_AND_COMMITS;
}
export class ResetCache {
  static readonly type = SupplyVisibilityActionType.RESET_CACHE;
}

export class ResetCommitTransactionDetails {
  static readonly type = SupplyVisibilityActionType.RESET_COMMIT_TRANSACTION_DETAILS;
}

export class ResetPlantDependentCache {
  static readonly type = SupplyVisibilityActionType.RESET_PLANT_DEPENDENT_CACHE;
}
export class ResetSupplyVisibilityPartNumberList {
  static readonly type = SupplyVisibilityActionType.RESET_SUPPLY_VISIBILITY_PART_NUMBER_LIST;
}

export class SetMaterialManagementViews {
  static readonly type = SupplyVisibilityActionType.SET_MATERIAL_MANAGEMENT_VIEWS;
  constructor(public readonly variant?: string) {}
}

export class SetActiveMMView {
  static readonly type = SupplyVisibilityActionType.SET_ACTIVE_MM_VIEW;
  constructor(public readonly mmView: string) {}
}

export class SetForecastRangeSelector {
  static readonly type = SupplyVisibilityActionType.SET_FORECAST_RANGE_SELECTOR;
  constructor(public readonly rangeSelector: object[]) {}
}

export class SetSVComments {
  static readonly type = SupplyVisibilityActionType.SET_SV_COMMENTS;
  constructor(
    public readonly vendor: string,
    public readonly partnumber: string,
    public readonly validatePN?: unknown,
  ) {}
}

export class SetSVCommentsSuccess {
  static readonly type = SupplyVisibilityActionType.SET_SV_COMMENTS_SUCCESS;
  constructor(public readonly comments: unknown) {}
}

export class SetSVCommentsError {
  static readonly type = SupplyVisibilityActionType.SET_SV_COMMENTS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class CreateSVComment {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_COMMENT;
  constructor(public readonly data: SVComments) {}
}

export class CreateSVCommentSuccess {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_COMMENT_SUCCESS;
  constructor(public readonly data: SVComments) {}
}

export class CreateSVCommentError {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_COMMENT_ERROR;
  constructor(public readonly data: unknown) {}
}

export class UpdateSVComment {
  static readonly type = SupplyVisibilityActionType.UPDATE_SV_COMMENT;
  constructor(public readonly data: SVComments) {}
}

export class UpdateSVCommentSuccess {
  static readonly type = SupplyVisibilityActionType.UPDATE_SV_COMMENT_SUCCESS;
  constructor(public readonly data: SVComments) {}
}

export class UpdateSVCommentError {
  static readonly type = SupplyVisibilityActionType.UPDATE_SV_COMMENT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteSVComment {
  static readonly type = SupplyVisibilityActionType.DELETE_SV_COMMENT;
  constructor(public readonly data: SVComments) {}
}

export class DeleteSVCommentSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_SV_COMMENT_SUCCESS;
  constructor(public readonly data: SVComments) {}
}

export class DeleteSVCommentError {
  static readonly type = SupplyVisibilityActionType.DELETE_SV_COMMENT_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetSVPredefinedComments {
  static readonly type = SupplyVisibilityActionType.SET_SV_PREDEFINED_COMMENTS;
  constructor(public readonly category: string) {}
}

export class CreateSVPredefinedComment {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_PREDEFINED_COMMENT;
  constructor(public readonly data: SVPredefinedComments) {}
}

export class UpdateSVPredefinedComment {
  static readonly type = SupplyVisibilityActionType.UPDATE_SV_PREDEFINED_COMMENT;
  constructor(public readonly data: SVPredefinedComments) {}
}

export class DeleteSVPredefinedComment {
  static readonly type = SupplyVisibilityActionType.DELETE_SV_PREDEFINED_COMMENT;
  constructor(public readonly data: SVPredefinedComments) {}
}

export class SetSVNotesByRecord {
  static readonly type = SupplyVisibilityActionType.SET_SV_NOTES_BY_RECORD;
  constructor(
    public readonly modul: string,
    public readonly key: string,
    public readonly searchText?: string,
    public readonly top?: number,
    public readonly skip?: number,
  ) {}
}

export class SetSVNotesByRecordSuccess {
  static readonly type = SupplyVisibilityActionType.SET_SV_NOTES_BY_RECORD_SUCCESS;
}

export class SetSVNotesByRecordError {
  static readonly type = SupplyVisibilityActionType.SET_SV_NOTES_BY_RECORD_ERROR;
  constructor(public readonly error: unknown) {}
}

export class CreateSVNote {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_NOTE;
  constructor(public readonly data: SVNotes) {}
}

export class CreateSVNoteSuccess {
  static readonly type = SupplyVisibilityActionType.CREATE_SV_NOTE_SUCCESS;
}

export class UpdateSVNote {
  static readonly type = SupplyVisibilityActionType.UPDATE_SV_NOTE;
  constructor(public readonly data: SVNotes) {}
}

export class DeleteSVNote {
  static readonly type = SupplyVisibilityActionType.DELETE_SV_NOTE;
  constructor(public readonly data: SVNotes) {}
}

export class SetUserAction {
  static readonly type = SupplyVisibilityActionType.SET_USER_ACTION;
  constructor(public readonly action: EnumSvSidebarSection) {}
}
//#region user setting

export class SetBuyersPartNumbers {
  static readonly type = SupplyVisibilityActionType.SET_BUYERS_PART_NUMBERS;
  constructor(public readonly buyer: string) {}
}
export class GetPNsPrecalculateProjectionByFilter {
  static readonly type = SupplyVisibilityActionType.GET_PNS_PRECALCULATE_PROJECTION_BY_FILTER;
  constructor(public readonly filter: FilterParams) {}
}

export class SetUserSettingParameters {
  static readonly type = SupplyVisibilityActionType.SET_USER_SETTING_PARAMETERS;
  constructor(public readonly parameters: UserSettingsParameters) {}
}

/* UserSettings */
export class SetUserSettings {
  static readonly type = SupplyVisibilityActionType.SET_USER_SETTINGS;
}

export class SetUserSettingsError {
  static readonly type = SupplyVisibilityActionType.SET_USER_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class SetUserSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.SET_USER_SETTINGS_SUCCESS;
}

export class AddUserSettings {
  static readonly type = SupplyVisibilityActionType.ADD_USER_SETTINGS;
  constructor(
    public readonly userSettings: UserSettings,
    public readonly updateIdInData: boolean = true,
  ) {}
}

export class EditUserSettings {
  static readonly type = SupplyVisibilityActionType.EDIT_USER_SETTINGS;
  constructor(
    public readonly userSettings: UserSettings,
    public readonly isNotificationRequired: boolean = true,
  ) {}
}

export class EditUserSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.EDIT_USER_SETTINGS_SUCCESS;
  constructor(public readonly isNotificationRequired: boolean = true) {}
}
export class EditUserSettingsError {
  static readonly type = SupplyVisibilityActionType.EDIT_USER_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}
export class SetPanelCacheSuccess {
  static readonly type = SupplyVisibilityActionType.SET_PANEL_CACHE_SUCCESS;
  constructor(public readonly widgetId: string) {}
}

export class DeleteUserSettings {
  static readonly type = SupplyVisibilityActionType.DELETE_USER_SETTINGS;
  constructor(public readonly key: string) {}
}

export class DeleteUserSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_USER_SETTINGS_SUCCESS;
}
export class DeleteUserSettingsError {
  static readonly type = SupplyVisibilityActionType.DELETE_USER_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}
export class AddUserSettingsError {
  static readonly type = SupplyVisibilityActionType.ADD_USER_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class AddUserSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.ADD_USER_SETTINGS_SUCCESS;
}

export class SetPnReviewed {
  static readonly type = SupplyVisibilityActionType.SET_PN_REVIEWED;
  constructor(public readonly pnReviewed: PnReviewed) {}
}

export class DeletePnFlags {
  static readonly type = SupplyVisibilityActionType.DELETE_PN_FLAGS;
  constructor(
    public readonly pnReviewed: PnReviewed,
    public readonly flag: string,
  ) {}
}
export class DeletePnFlagsSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_PN_FLAGS_SUCCESS;
  constructor(public readonly pnReviewed?: PnReviewed) {}
}

export class DeletePnFlagsError {
  static readonly type = SupplyVisibilityActionType.DELETE_PN_FLAGS_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class SetPnReviewedError {
  static readonly type = SupplyVisibilityActionType.SET_PN_REVIEWED_ERROR;
  constructor(
    public readonly error: unknown,
    public readonly pnReviewed?: PnReviewed,
  ) {}
}

export class SetPnReviewedSuccess {
  static readonly type = SupplyVisibilityActionType.SET_PN_REVIEWED_SUCCESS;
  constructor(public readonly pnReviewed?: PnReviewed) {}
}

export class SliderChangeForMultiPN {
  static readonly type = SupplyVisibilityActionType.SLIDER_CHANGE_FOR_MULTI_PN;
  constructor(public readonly data: unknown) {}
}

export class SetNewUserVendorCodesRights {
  static readonly type = SupplyVisibilityActionType.SET_NEW_USER_VENDOR_CODES_RIGHTS;
  constructor(public readonly data: unknown) {}
}

export class SetUpdateUserVendorCodesRights {
  static readonly type = SupplyVisibilityActionType.SET_UPDATE_USER_VENDOR_CODES_RIGHTS;
  constructor(public readonly data: unknown) {}
}

export class CacheCommitsReasons {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_REASONS;
  constructor(public readonly refresh?: boolean) {}
}

export class CacheCommitsReasonsSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_REASONS_SUCCESS;
}

export class CacheCommitsReasonsError {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_REASONS_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class CacheCommitsCountries {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_COUNTRIES;
  constructor(public readonly refresh?: boolean) {}
}

export class CacheCommitsCountriesSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_COUNTRIES_SUCCESS;
}
export class CacheCommitsCountriesError {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_COUNTRIES_ERROR;
  constructor(public readonly error?: unknown) {}
}
export class CacheCommitsCarriers {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_CARRIERS;
  constructor(public readonly refresh?: boolean) {}
}

export class CacheCommitsCarriersSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_CARRIERS_SUCCESS;
}

export class CacheCommitsCarriersError {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_CARRIERS_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class CacheCommitsTransportType {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_TRANSPORT_TYPE;
  constructor(public readonly refresh?: boolean) {}
}

export class CacheCommitsTransportTypeSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_TRANSPORT_TYPE_SUCCESS;
}

export class CacheCommitsTransportTypeError {
  static readonly type = SupplyVisibilityActionType.CACHE_COMMITS_TRANSPORT_TYPE_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class SetWidgetCache {
  static readonly type = SupplyVisibilityActionType.SET_WIDGET_CACHE;
  constructor(public readonly widget: DashboardPanelModel) {}
}
export class CacheReadOnlyFields {
  static readonly type = SupplyVisibilityActionType.CACHE_READ_ONLY_FIELDS;
  constructor(public readonly refresh?: boolean) {}
}

export class CacheReadOnlyFieldsSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_READ_ONLY_FIELDS_SUCCESS;
  constructor(public readonly readonlyFieldsData?: unknown) {}
}
export class CacheReadOnlyFieldsError {
  static readonly type = SupplyVisibilityActionType.CACHE_READ_ONLY_FIELDS_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class GetFilterAdditions {
  static readonly type = SupplyVisibilityActionType.GET_FILTER_ADDITIONS;
}

export class GetFilterAdditionsSuccess {
  static readonly type = SupplyVisibilityActionType.GET_FILTER_ADDITIONS_SUCCESS;
  constructor(public readonly data?: unknown) {}
}

export class GetFilterAdditionsError {
  static readonly type = SupplyVisibilityActionType.GET_FILTER_ADDITIONS_ERROR;
  constructor(public readonly error?: unknown) {}
}
export class SetPlantMandatoryDates {
  static readonly type = SupplyVisibilityActionType.SET_PLANT_MANDATORY_DATES;
  constructor(public readonly refresh?: boolean) {}
}

export class SetPlantMandatoryDatesSuccess {
  static readonly type = SupplyVisibilityActionType.SET_PLANT_MANDATORY_DATES_SUCCESS;
}

export class SetPlantMandatoryDatesError {
  static readonly type = SupplyVisibilityActionType.SET_PLANT_MANDATORY_DATES_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class DownloadNotificationFile {
  static readonly type = SupplyVisibilityActionType.DOWNLOAD_NOTIFICATION_FILE;
  constructor(public readonly url: string) {}
}

export class HandleLinkEvents {
  static readonly type = SupplyVisibilityActionType.HANDLE_LINK_EVENTS;
  constructor(public readonly event: string) {}
}
export class HandleLinkEventsSuccess {
  static readonly type = SupplyVisibilityActionType.HANDLE_LINK_EVENTS_SUCCESS;
  constructor(public readonly event?: unknown) {}
}
export class HandleLinkEventsError {
  static readonly type = SupplyVisibilityActionType.HANDLE_LINK_EVENTS_ERROR;
  constructor(public readonly event?: unknown) {}
}
export class TriggerLinkEventCommitDialog {
  static readonly type = SupplyVisibilityActionType.TRIGGER_LINK_EVENT_COMMIT_DIALOG;
  constructor(public readonly event: { eventName: string; eventValue: unknown }) {}
}

export class SetCommitTransactionDetails {
  static readonly type = SupplyVisibilityActionType.SET_COMMIT_TRANSACTION_DETAILS;
  constructor(public readonly commitTransactionDetails: CommitTransactionDetails) {}
}

export class PatchCommitTransactionDetails {
  static readonly type = SupplyVisibilityActionType.PATCH_COMMIT_TRANSACTION_DETAILS;
  constructor(public readonly commitTransactionDetails: CommitTransactionDetails[]) {}
}

export class SetVendorTransactionDetails {
  static readonly type = SupplyVisibilityActionType.SET_VENDOR_TRANSACTION_DETAILS;
  constructor(public readonly vendorTransactionDetails: VendorTransactionDetails) {}
}

export class PatchVendorTransactionDetails {
  static readonly type = SupplyVisibilityActionType.PATCH_VENDOR_TRANSACTION_DETAILS;
  constructor(public readonly vendorTransactionDetails: VendorTransactionDetails[]) {}
}

// export class SetQuotationTransactionDetails {
//   static readonly type = SupplyVisibilityActionType.SET_QUOTATION_TRANSACTION_DETAILS;
//   constructor(public readonly quotationTransactionDetails: QuotationTransactionDetails) {}
// }

// export class PatchQuotationTransactionDetails {
//   static readonly type = SupplyVisibilityActionType.PATCH_QUOTATION_TRANSACTION_DETAILS;
//   constructor(public readonly quotationTransactionDetails: QuotationTransactionDetails[]) {}
// }

export class SetPartNumberTransactionDetails {
  static readonly type = SupplyVisibilityActionType.SET_PART_NUMBER_TRANSACTION_DETAILS;
  constructor(public readonly partnumberTransactionDetails: PartNumberTransactionDetails) {}
}

export class PatchPartNumberTransactionDetails {
  static readonly type = SupplyVisibilityActionType.PATCH_PART_NUMBER_TRANSACTION_DETAILS;
  constructor(public readonly partnumberTransactionDetails: PartNumberTransactionDetails[]) {}
}

export class GetDefaultFieldsSuccess {
  static readonly type = SupplyVisibilityActionType.GET_DEFAULT_FIELDS_SUCCESS;
  constructor(public readonly defaultFields: unknown) {}
}

export class CacheVendorsName {
  static readonly type = SupplyVisibilityActionType.CACHE_VENDORS_NAME;
  constructor(public readonly onlyForBuy?: boolean) {}
}

export class CacheVendorsNameSuccess {
  static readonly type = SupplyVisibilityActionType.CACHE_VENDORS_NAME_SUCCESS;
  constructor(public readonly response?: VendorName[]) {}
}

export class CacheVendorsNameError {
  static readonly type = SupplyVisibilityActionType.CACHE_VENDORS_NAME_ERROR;
  constructor(public readonly error?: unknown) {}
}
//#endregion

export class SetDefaultDashboardSettings {
  static readonly type = SupplyVisibilityActionType.SET_DEFAULT_DASHBOARD_SETTINGS;
  constructor(
    public readonly data: unknown,
    public readonly key: unknown,
  ) {}
}

export class SetCommitStatus {
  static readonly type = SupplyVisibilityActionType.SET_COMMIT_STATUS;
  constructor(public readonly status: string) {}
}

export class SetAdditionalFilters {
  static readonly type = SupplyVisibilityActionType.SET_ADDITIONAL_FILTERS;
  constructor(public readonly filters: unknown) {}
}

export class GetMultiProjections {
  static readonly type = SupplyVisibilityActionType.GET_MULTI_PROJECTIONS;
  constructor(public readonly payload: CumulativePayload) {}
}

export class GetMultiProjectionsSuccess {
  static readonly type = SupplyVisibilityActionType.GET_MULTI_PROJECTIONS_SUCCESS;
  constructor(public readonly res: Forecast[]) {}
}

export class GetMultiProjectionsError {
  static readonly type = SupplyVisibilityActionType.GET_MULTI_PROJECTIONS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class GetTemplateSettings {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS;
  constructor(public readonly params: TemplatePayload) {}
}

export class GetTemplateSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS_SUCCESS;
  constructor(public readonly res: unknown) {}
}

export class GetTemplateSettingsError {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class GetTemplateSettingsByID {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS_BY_ID;
  constructor(public readonly id: string) {}
}

export class GetTemplateSettingsByIDSuccess {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS_BY_ID_SUCCESS;
  constructor(public readonly res: unknown) {}
}

export class GetTemplateSettingsByIDError {
  static readonly type = SupplyVisibilityActionType.GET_TEMPLATE_SETTINGS_BY_ID_ERROR;
  constructor(public readonly error: unknown) {}
}

export class UpdateTemplateSettings {
  static readonly type = SupplyVisibilityActionType.UPDATE_TEMPLATE_SETTINGS;
  constructor(public readonly payload: TemplatePayload) {}
}

export class UpdateTemplateSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.UPDATE_TEMPLATE_SETTINGS_SUCCESS;
  constructor(public readonly res: unknown) {}
}

export class UpdateTemplateSettingsError {
  static readonly type = SupplyVisibilityActionType.UPDATE_TEMPLATE_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class CreateTemplateSettings {
  static readonly type = SupplyVisibilityActionType.CREATE_TEMPLATE_SETTINGS;
  constructor(public readonly data: unknown) {}
}

export class CreateTemplateSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.CREATE_TEMPLATE_SETTINGS_SUCCESS;
  constructor(public readonly res: unknown) {}
}

export class CreateTemplateSettingsError {
  static readonly type = SupplyVisibilityActionType.CREATE_TEMPLATE_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}

export class DeleteTemplateSettings {
  static readonly type = SupplyVisibilityActionType.DELETE_TEMPLATE_SETTINGS;
  constructor(public readonly id: string) {}
}

export class DeleteTemplateSettingsSuccess {
  static readonly type = SupplyVisibilityActionType.DELETE_TEMPLATE_SETTINGS_SUCCESS;
}

export class DeleteTemplateSettingsError {
  static readonly type = SupplyVisibilityActionType.DELETE_TEMPLATE_SETTINGS_ERROR;
  constructor(public readonly error: unknown) {}
}
